import React from "react";
import AllSensorChart from "../../Components/AllSensorChart/index";
import "./index.css";

function Sensores() {
  return (
    <div id="divChart">
      <AllSensorChart id="chartAllSensor" />
    </div>
  );
}

export default Sensores;
